import * as Sentry from '@sentry/react';

import { SENTRY_PROJECT_NAME } from '../constants';

import type { FastShiftState } from './reducer';

export const getUserDomain = (state: FastShiftState) => {
	return state.userAccess.data?.userDomain?.domain;
};

export const captureErrorWithContext = ({
	error,
	message,
	userDomain,
}: {
	error: string;
	message: string;
	userDomain?: string;
}) => {
	Sentry.captureException(new Error(error), {
		tags: {
			projectName: SENTRY_PROJECT_NAME,
		},
		extra: {
			errorMessage: message,
			userDomain: userDomain || '',
		},
	});
};

export const getRunbookStepActionKey = ({
	runbookId,
	stepId,
}: {
	runbookId: string;
	stepId: string;
}) => `${runbookId}:${stepId}`;
